module.exports = __webpack_public_path__ + "static/media/5.2ff6366f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/5.mp3
// module id = 481
// module chunks = 0